import React from "react";
import { Col, Container, Row } from "react-bootstrap";
// import RecipeBrief from './recipe-brief';
import RecipeMain from "./recipe-main";
import { Fade } from "react-reveal";

function RecipeInfo(props) {
  return (
    <section className="recipe-info">
      <header id="recipe-header" className="text-center">
        <Fade duration={2500}>
          <h2 className="recipe-info-title">{props.recipeDetails.title}</h2>
        </Fade>
      </header>
      <div className="recipe-intro-container">
        <Container>
          <Row className="justify-content-md-center">
            <Col sm={10}>
              <h4 className="recipe-intro black-text">
                {props.recipeDetails.introduction}
              </h4>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="recipe-details justify-content-md-center">
          {/* <Col lg="4">
            <RecipeBrief imgSrc={props.recipeDetails.imageLink} title={props.recipeDetails.title}/>
          </Col> */}
          <Col md="10">
            <RecipeMain
              introduction={props.recipeDetails.introduction}
              youtubeLink={props.recipeDetails.youtubeLink}
              sets={props.recipeDetails.ingredientSets}
              methods={props.recipeDetails.methods}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default RecipeInfo;
